import React from "react";
import cleanQnToken from "@qn/services/api/cleanQnToken";
import StorageManager from "@/utils/StorageManager";

const useLogoutEffect = () => {
    React.useEffect(() => {
        if (import.meta.env.VITE_IS_QN) {
            cleanQnToken();
        } else {
            StorageManager.removeToken();
        }
    }, []);
};

export default useLogoutEffect;
